module.exports = __webpack_public_path__ + "img/Facebook Button.5fe0356e.svg";